import { render, staticRenderFns } from "./RowsPlaceholder.vue?vue&type=template&id=117a9c08&scoped=true&"
import script from "./RowsPlaceholder.vue?vue&type=script&lang=js&"
export * from "./RowsPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./RowsPlaceholder.vue?vue&type=style&index=0&id=117a9c08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117a9c08",
  null
  
)

export default component.exports